import tableOperation from '../common/table-operation'

const getSearchedNumberPools = function (state) {
  const { table, numberPools } = state
  const { searchText = '' } = table

  const matchNumberPoolName = (currentNumberPool, value) =>
    currentNumberPool?.name?.toLowerCase()?.includes(value?.toLowerCase())

  const matchNumberPoolSource = (currentNumberPool, value) =>
    currentNumberPool?.source?.toLowerCase()?.includes(value?.toLowerCase())

  const matchNumberPoolForwardingNumber = (currentNumberPool, value) =>
    currentNumberPool?.forwarding_number
      ?.toLowerCase()
      ?.includes(value?.toLowerCase())

  const searchedNumberPools = tableOperation.applyClientSideFilter({
    searchQuery: searchText,
    filterConditions: [
      matchNumberPoolName,
      matchNumberPoolSource,
      matchNumberPoolForwardingNumber,
    ],
    collection: numberPools,
  })

  return searchedNumberPools
}

export default getSearchedNumberPools
